import React from 'react';
import RenderSteps from './RenderSteps';
const NewCourse = () => {
    return (
        <div className='text-richblack-5'>
            <div>
                <div>
                    <header className='text-3xl font-medium'>Launch New Course</header>
                    <div className='py-10'>
                        <RenderSteps />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewCourse;